import { Component } from "@angular/core";

@Component({
  selector: "standalone-sidebar-content",
  template: " <ng-content></ng-content>",
  styleUrls: ["./standalone-sidebar-content.component.scss"],
})
export class StandaloneSidebarContentComponent {}
